import { useViewport } from './useViewport';

export function useLeapCustomizations() {
  const { width } = useViewport();

  const inputSize = computed(() => (width.value < 1024 ? 'l' : 'xl'));
  const cardPadding = computed(() => (width.value < 1024 ? 's' : 'm'));

  return {
    inputSize,
    cardPadding,
  };
}
